import AxiosInstance from "@/config/AxiosInstance";
import { API_BASE_URL } from "@/config/appConfig";

export const locationService = {
  getLocationDetails,
  getLocationListByUserAndBrand,
};

function getLocationDetails(id: unknown) {
  return AxiosInstance.get(`${API_BASE_URL}/getLocationDetails/${id}`);
}

function getLocationListByUserAndBrand({
  row,
  brand_id,
  page,
}: {
  row?: unknown;
  brand_id?: unknown;
  page?: unknown;
}) {
  return AxiosInstance.get(`${API_BASE_URL}/location-list-by-userId`, {
    params: { row, page, brand_id },
  });
}
